// extracted by mini-css-extract-plugin
export default {"googleSvg":"SignUp_googleSvg__PTGZq","container":"SignUp_container__iAaja","container2":"SignUp_container2__hIBEB","input":"SignUp_input__m9ZBZ"};